import {
  IConfidence,
  IMetricSettings,
  IMetricSnapshot,
  IMetricTrend,
  IMetricUI,
  MetricCascadeType,
  MetricTargetOperator,
} from "@webapp/okrs/metrics/models/metric.models";
import { IUnitFormatting } from "@gtmhub/shared/models";
import { CfMap } from "@gtmhub/customFields";
import { IGif, INewComment } from "@gtmhub/comments";
import { Links } from "@webapp/links/models/links.models";
import { IOkrClosedStatus } from "@webapp/okrs/goals/models/goal-status.models";

// to do: when this IMetric model is refactored IAlignmentTreeMetric can be refactored as well to extend metric base, extract props from other etc.
export interface IMetric extends IMetricUI {
  id?: string;
  accountId?: string;
  name?: string;
  goalId?: string;
  goalName?: string;
  sessionId?: string;
  insightName?: string;
  fieldName?: string;
  settings?: IMetricSettings[];
  targetOperator?: MetricTargetOperator;
  target?: number;
  critical?: number;
  initialValue?: number;
  actual?: number;
  attainment?: number;
  progressStatus?: string;
  trend?: IMetricTrend[];
  manualType?: string;
  softDueDate?: string;
  dueDate?: string;
  description?: string;
  goalClosedStatus?: Pick<IOkrClosedStatus, "status">;
  customFields?: CfMap;
  lastCheckInDate?: string;
  metricHistory?: IMetricSnapshot[];
  confidence?: IConfidence;
  format?: IUnitFormatting;
  links?: Links<"metric">;
  obfuscated?: boolean;
  cascadeType?: MetricCascadeType;
  ownerIds?: string[];
  sourceMetricId?: string;
  dynamic?: boolean;
  // Used for drag & drop list in single goal modal
  childType?: "metric";
  orderId?: number;
}

export interface ICheckin {
  id?: string;
  actual?: number;
  checkInDate?: string;
  createdAt?: string;
  confidence?: number;
  comment?: string;
  changedBy?: string;
  customFields?: CfMap;
  simulateAutomaticCheckin?: boolean;
  gif?: IGif;
}

export interface ICheckinV2 {
  format: IUnitFormatting;
  accountId: string;
  attainment: number;
  attainmentChange: number;
  comment: string;
  confidenceValue: number;
  createdAt: string;
  date: string;
  goalId: string;
  id: string;
  metricId: string;
  modifiedBy: string;
  modifiedByInfo: {
    accountId: string;
    avatar: string;
    color: string;
    email: string;
    id: string;
    name: string;
    picture: string;
    type: string;
  };
  name: string;
  ownerId: string;
  target: number;
  targetOperator: string;
  manualType: string;
  value: number;
  gif?: IGif;
  newComment?: INewComment;

  // ux
  showForm: boolean;
}

export enum MetricFormEventType {
  KR_FORM_OPENED = "KR Form Opened",
  KR_FORM_CLOSED = "KR Form Closed",
}

export enum MetricType {
  DYNAMIC = "dynamic",
  MANUAL = "manual",
}

export enum MetricFormState {
  EDIT = "edit",
  CREATE = "create",
}

export interface IMetricsQueryParamsOptions {
  goalIds?: string;
  ids?: string;
}
